import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';

import { FullComponent } from './full/full.component';
import { BlankComponent } from './blank/blank.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SharedModule
    ],
    declarations: [
        FullComponent,
        BlankComponent
    ],
    exports: [FullComponent, BlankComponent],
    providers: []
})

export class LayoutModule { }
